/**
 * @flow
 * @relayHash 2c231129201b21a8e2f32afc198b76ab
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReceiptHistoryQueryVariables = {|
  first?: ?number,
  purchaseOrderId?: ?string,
|};
export type ReceiptHistoryQueryResponse = {|
  +poReceiptHistory: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +purchaseOrder: {|
          +id: string,
          +poNumber: string,
        |},
        +receivedBy: {|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +receivedAt: any,
        +notes: ?string,
        +receiptLines: $ReadOnlyArray<{|
          +id: string,
          +item: {|
            +id: string,
            +itemNumber: string,
            +name: string,
          |},
          +quantityReceived: number,
          +lotNumber: ?string,
        |}>,
      |}
    |}>,
    +totalCount: number,
  |}
|};
export type ReceiptHistoryQuery = {|
  variables: ReceiptHistoryQueryVariables,
  response: ReceiptHistoryQueryResponse,
|};
*/


/*
query ReceiptHistoryQuery(
  $first: Int
  $purchaseOrderId: ID
) {
  poReceiptHistory(first: $first, purchaseOrderId: $purchaseOrderId) {
    edges {
      node {
        id
        purchaseOrder {
          id
          poNumber
        }
        receivedBy {
          id
          firstName
          lastName
        }
        receivedAt
        notes
        receiptLines {
          id
          item {
            id
            itemNumber
            name
          }
          quantityReceived
          lotNumber
        }
        __typename
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "purchaseOrderId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "purchaseOrderId",
  "variableName": "purchaseOrderId"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "POReceiptEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "POReceipt",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "purchaseOrder",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "receivedBy",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "receivedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "receiptLines",
            "storageKey": null,
            "args": null,
            "concreteType": "POReceiptLine",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityReceived",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lotNumber",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalCount",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReceiptHistoryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "poReceiptHistory",
        "name": "__ReceiptHistory_poReceiptHistory_connection",
        "storageKey": null,
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "POReceiptConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ReceiptHistoryQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poReceiptHistory",
        "storageKey": null,
        "args": (v4/*: any*/),
        "concreteType": "POReceiptConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "poReceiptHistory",
        "args": (v4/*: any*/),
        "handle": "connection",
        "key": "ReceiptHistory_poReceiptHistory",
        "filters": [
          "purchaseOrderId"
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ReceiptHistoryQuery",
    "id": null,
    "text": "query ReceiptHistoryQuery(\n  $first: Int\n  $purchaseOrderId: ID\n) {\n  poReceiptHistory(first: $first, purchaseOrderId: $purchaseOrderId) {\n    edges {\n      node {\n        id\n        purchaseOrder {\n          id\n          poNumber\n        }\n        receivedBy {\n          id\n          firstName\n          lastName\n        }\n        receivedAt\n        notes\n        receiptLines {\n          id\n          item {\n            id\n            itemNumber\n            name\n          }\n          quantityReceived\n          lotNumber\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "poReceiptHistory"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '358f65786577b78f7925d90dd89ffdf7';
module.exports = node;
